export const SavingsOptionsRoutes = {
    ROOT: "/savings-options",
    SIGNING: "/savings-options/signing",
    SUCCESS: "/savings-options/success"
};



// WEBPACK FOOTER //
// ./src/components/savingsOptions/SavingsOptionsRoutes.ts